import { FormControlLabel, formGroupClasses, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import React from "react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CircuitCreateStepperData, CircuitCreateStepperStockType } from "./circuitCreateStepper";

interface CircuitCreateStepperPackageWithoutProductProps {
    data: CircuitCreateStepperData;
    setData: React.Dispatch<React.SetStateAction<CircuitCreateStepperData>>;
    stepIndex: number
}

export const CircuitCreateStepperPackageWithoutProduct: FC<CircuitCreateStepperPackageWithoutProductProps> = ({ data, setData, stepIndex }) => {
    const { t } = useTranslation();
    const onChange = (event: { target: { name: any; value: any; }; }) => {
        setData((state) => ({ ...state, [event.target.name]: !!event.target.value, ['stock_type']: CircuitCreateStepperStockType.STOCK_ON_THE_PACKAGE }));
    };
    return (
        <Stack direction={'column'} justifyContent={'center'} sx={{ maxWidth: 'md', width: '100%', gap: 7 }}>
            <Stack direction={'column'} spacing={1}>
                <Typography variant="h3" sx={{ color: '#486284', fontWeight: 700 }}>{t('shared.step-number', { count: stepIndex + 1 })} : {t('shared.products')}</Typography>
                <Typography variant="subtitle1" sx={{ color: '#8CA2C0', fontWeight: 400 }}>{t('shared.package-without-product-helper-text')}</Typography>
            </Stack>
            <Stack direction={'row'} alignItems={'center'} sx={{ width: '100%' }} spacing={2}>
                <RadioGroup
                    value={data.without_products ? 'true' : ''}
                    name="without_products"
                    onChange={onChange}
                    sx={{
                        [`&.${formGroupClasses.root}`]: {
                            gap: 2
                        }
                    }}
                >
                    <FormControlLabel
                        value={'true'}
                        control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '1.7rem' } }} />}
                        label={t("shared.package-without-product")}
                        componentsProps={{ typography: { sx: { fontSize: '1.5rem' }, variant: 'body1' } }}
                    />
                    <FormControlLabel
                        value={''}
                        control={<Radio sx={{ '& .MuiSvgIcon-root': { fontSize: '1.7rem' } }} />}
                        label={t("shared.package-with-product")}
                        componentsProps={{ typography: { sx: { fontSize: '1.5rem', variant: 'body1' } } }}
                    />
                </RadioGroup>

            </Stack>
        </Stack>
    );
};